import { render, staticRenderFns } from "./PopularPeople.vue?vue&type=template&id=8d562b94&scoped=true&"
import script from "./PopularPeople.vue?vue&type=script&lang=js&"
export * from "./PopularPeople.vue?vue&type=script&lang=js&"
import style0 from "./PopularPeople.vue?vue&type=style&index=0&id=8d562b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d562b94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCol,VContainer,VImg})
